'use client';

import React, { useMemo } from 'react';

import { useShoppingCartContext } from '@/components/Providers/ShoppingCartProvider';
import { BASIC_START_KIT_ITEM_CODE, BUILD_YOUR_PACK_ITEM_CODE } from '@/helpers/utils/enrollmentFlowTracker';

const CartUpperDescriptionSection = () => {
  const { isEnrollmentFlow, cart } = useShoppingCartContext();

  // Check if cart contains ONLY BYP or Basic Start Kit items
  const hasOnlyEnrollmentKitItems = useMemo(() => {
    if (!cart || cart.length === 0) return false;

    // Check if all items in cart are either BYP or Basic Start Kit
    return cart.every(item => {
      const itemCode = String(item.itemCode || item.id);
      return itemCode === BUILD_YOUR_PACK_ITEM_CODE || itemCode === BASIC_START_KIT_ITEM_CODE;
    });
  }, [cart]);

  // Show the text only if:
  // 1. It's an enrollment flow AND
  // 2. Cart does NOT contain only enrollment kit items (meaning there are other items)
  const shouldShowText = !hasOnlyEnrollmentKitItems;

  return (
    <>
      <h2 className="v2-font-sweet-sans-pro v2-text-[23px] sm:v2-text-3xl v2-text-primary v2-mb-[20px] sm:v2-mb-[18px]">
        {isEnrollmentFlow ? 'Enjoy Complementary Shipping' : 'Become A Paw Club Member!'}
      </h2>
      <div className="v2-mb-10">
        {shouldShowText && (
          <>
            <p className="v2-font-sweet-sans-pro-light v2-text-[#101828] v2-text-lg md:v2-text-lg sm:v2-text-base xs:v2-text-base v2-block">
              Just create an EZ-Ship recurring order then enjoy FREE or discounted shipping, earn points for every
              dollar spent and more.
            </p>
            <p className="v2-font-sweet-sans-pro-light v2-text-[#101828] v2-text-lg md:v2-text-lg sm:v2-text-base xs:v2-text-base v2-hidden">
              Just create an EZ-Ship recurring order then enjoy FREE or discounted shipping, earn points for every
              dollar spent and more.
            </p>
          </>
        )}
      </div>
    </>
  );
};

export default CartUpperDescriptionSection;
